import { useWebsite } from '../../context/WebsiteContext';
import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { Lock, Mail } from 'lucide-react';
import { useAuth } from '../../context/AuthContext';
import { Toaster, toast } from 'sonner';

const AdminLoginPage = () => {
  const { config: website } = useWebsite();
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [loading, setLoading] = useState(false);
  const { login } = useAuth();
  const navigate = useNavigate();

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    const result = await login(email, password);
    if (result.success) {
      toast.success('Login successful!');
      navigate('/admin');
    } else {
      toast.error(result.error || 'Login failed');
    }
    setLoading(false);
  };

  return (
    <div className="min-h-screen bg-[#1B3A5C] flex items-center justify-center px-4" data-testid="admin-login-page">
      <Toaster position="top-right" richColors />
      <div className="w-full max-w-md">
        <div className="text-center mb-8">
          <img
            src={website.logo}
            alt="KYIS Logo" className="h-20 w-auto mx-auto mb-6 brightness-0 invert opacity-90"
          />
          <h1 className="text-2xl font-bold text-white">Admin Login</h1>
          <p className="text-blue-200/60 mt-2">Sign in to access the admin dashboard</p>
        </div>

        <div className="p-8 bg-white rounded-2xl shadow-xl">
          <form onSubmit={handleSubmit} className="space-y-6" data-testid="login-form">
            <div>
              <label className="block text-sm font-medium mb-2 text-gray-700">Email</label>
              <div className="relative">
                <input type="email" value={email} onChange={(e) => setEmail(e.target.value)} required
                  className="w-full px-4 py-3 pl-10 bg-gray-50 border border-gray-200 rounded-xl focus:outline-none focus:ring-2 focus:ring-[#4A90A4] text-gray-900"
                  placeholder="admin@shopkyis.com" data-testid="login-email" />
                <Mail className="absolute left-3 top-1/2 -translate-y-1/2 w-5 h-5 text-gray-400" />
              </div>
            </div>
            <div>
              <label className="block text-sm font-medium mb-2 text-gray-700">Password</label>
              <div className="relative">
                <input type="password" value={password} onChange={(e) => setPassword(e.target.value)} required
                  className="w-full px-4 py-3 pl-10 bg-gray-50 border border-gray-200 rounded-xl focus:outline-none focus:ring-2 focus:ring-[#4A90A4] text-gray-900"
                  placeholder="••••••••" data-testid="login-password" />
                <Lock className="absolute left-3 top-1/2 -translate-y-1/2 w-5 h-5 text-gray-400" />
              </div>
            </div>
            <button type="submit" disabled={loading}
              className="w-full py-3 bg-[#F5A623] text-gray-900 font-bold rounded-full btn-glow disabled:opacity-50"
              data-testid="login-submit"
            >
              {loading ? 'Signing in...' : 'Sign In'}
            </button>
          </form>
        </div>
      </div>
    </div>
  );
};

export default AdminLoginPage;
